import { render } from "./UpdateChecker.vue?vue&type=template&id=f80cd312&scoped=true"
import script from "./UpdateChecker.vue?vue&type=script&lang=js"
export * from "./UpdateChecker.vue?vue&type=script&lang=js"

import "./UpdateChecker.vue?vue&type=style&index=0&id=f80cd312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f80cd312"]])

export default __exports__